import { render } from "./PricesContent.vue?vue&type=template&id=35887e45&scoped=true"
import script from "./PricesContent.vue?vue&type=script&lang=js"
export * from "./PricesContent.vue?vue&type=script&lang=js"

import "./PricesContent.vue?vue&type=style&index=0&id=35887e45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35887e45"]])

export default __exports__